import type { ComponentProps } from 'react'
import InjuredParty from '../../shared/InjuredParty'

type Props = ComponentProps<typeof InjuredParty>

export default function Step2_InjuredParty(props: Props) {
  return <InjuredParty {...props} />
}

